/* eslint-disable prettier/prettier */
import moment from "moment";
import store from "@/store";
import axios from "axios";

const fileMethods = {
  async getFiles(filesIds) {
    const files = [];
    if (filesIds !== undefined && filesIds !== null && filesIds.length > 0) {
      const settings = store.getters["common/settings"];
      const result = (await axios.post(
        `${settings.DOCUMENTSERVICEURL}api/Files`,
        filesIds
      )).data;

      for (const item of result) {
        const newfile = await this.makeFile(item);
        const internalItem = { file: item, File: newfile };
        internalItem.description = this.createDescription(internalItem);
        files.push(internalItem);
      }
    }
    return files;
  },
  async makeFile(item) {
    const settings = store.getters["common/settings"];
    const res = (await axios.get(`${settings.DOCUMENTSERVICEURL}api/UploadFiles/${item.Id}`)).data;
    const blob = this.b64toBlob(res);
    return new File([blob], item.Name, { type: blob.type });
  },
  createDescription(item) {
    return (
      item.file.Name.substring(0, 20) +
      "..." +
      item.file.Name.slice(item.file.Name.length - 20) +
      "--" +
      new Date(Date.parse(item.file.DateCreated)).toLocaleString()
    );
  },
  b64toBlob(b64Data, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (
      let offset = 0;
      offset < byteCharacters.length;
      offset += sliceSize
    ) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  },
  // async downloadFiles() {
    
  //   const ids = this.selectedFile.FileSegments.map((o) => o.PhysicalFileId);
  //   try {
  //     const res = (await this.downloadFile({ ids: ids })).data;
  //     // const blob = window.URL.createObjectURL(
  //     //   new Blob([base64ToArrayBuffer(res)])
  //     // );
  //     const blob = this.b64toBlob(res);
  //     // const name = this.selectedFile.FileSegments[0].FileName;
  //     const name =
  //       ids.length > 1
  //         ? "files.zip"
  //         : this.selectedFile.FileSegments[0].FileName;
  //     saveAs(blob, name);
  //   } catch (error) {
  //     this.error = error;
  //   } finally {
  //     this.loadingFile = false;
  //   }
  // },
  // readFileAsTextAsync(file) {
  //   return new Promise((resolve, reject) => {
  //     let reader = new FileReader();

  //     reader.onload = () => {
  //       resolve(reader.result);
  //     };

  //     reader.onerror = reject;

  //     reader.readAsText(file);
  //   });
  // },
  // readFileAsDataUrlAsync(file) {
  //   return new Promise((resolve, reject) => {
  //     let reader = new FileReader();

  //     reader.onload = () => {
  //       resolve(reader.result);
  //     };

  //     reader.onerror = reject;

  //     reader.readAsDataURL(file);
  //   });
  // },
};

const files = {
  install(Vue) {
    Vue.prototype.$files = fileMethods;
  },
};

export default files;
